interface PortalPageHeaderProps {
  title: string;
  helperText: string;
}

export function PortalPageHeader({ title, helperText }: PortalPageHeaderProps) {
  return (
    <div className="mb-5">
      <h1 className="text-xl sm:text-2xl font-bold text-zooindigo">{title}</h1>
      <p className="text-sm text-zoomuted mt-1">{helperText}</p>
    </div>
  );
}
